import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isConfigured } = useAuth();

  async function handleSubmit(e) {
    e.preventDefault();

    if (!isConfigured) {
      setError('Firebase is not configured. Please set up your Firebase configuration.');
      return;
    }

    try {
      setError('');
      setLoading(true);
      await login(email, password);
      // After successful login, redirect will be handled by PrivateRoute
      window.location.href = '/dashboard';
    } catch (error) {
      console.error('Login error:', error);
      if (error.code === 'auth/user-not-found') {
        setError('No account found with this email.');
      } else if (error.code === 'auth/wrong-password') {
        setError('Incorrect password.');
      } else if (error.code === 'auth/invalid-email') {
        setError('Invalid email address.');
      } else if (error.code === 'auth/too-many-requests') {
        setError('Too many failed attempts. Please try again later.');
      } else {
        setError('Failed to log in. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className='min-h-screen bg-[#FFB7CE] flex items-center justify-center px-4'>
      <div className='bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md'>
        <div className='text-center mb-8'>
          <h1 className='text-4xl font-bold text-[#FFB7CE] mb-2'>KHULWAEL</h1>
          <p className='text-gray-600'>Admin Portal</p>
        </div>

        {!isConfigured && (
          <div className='bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-6 rounded'>
            <p className='font-bold text-sm'>⚠️ Firebase Not Configured</p>
            <p className='text-xs mt-1'>
              Please set up Firebase to enable authentication.
            </p>
          </div>
        )}

        {error && (
          <div className='bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-6 rounded'>
            <p className='text-sm'>{error}</p>
          </div>
        )}

        <div className='space-y-6'>
          <div>
            <label className='block text-gray-700 font-medium mb-2'>Email</label>
            <input
              type='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className='w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FFB7CE] transition-all'
              placeholder='admin@example.com'
            />
          </div>

          <div>
            <label className='block text-gray-700 font-medium mb-2'>Password</label>
            <input
              type='password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className='w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FFB7CE] transition-all'
              placeholder='••••••••'
            />
          </div>

          <button
            onClick={handleSubmit}
            disabled={loading || !isConfigured}
            className='w-full bg-[#FFB7CE] hover:bg-[#FF9BB8] text-white font-bold py-3 rounded-lg transition-colors duration-200 disabled:bg-gray-300 disabled:cursor-not-allowed'
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </div>

        <div className='mt-6 text-center text-sm text-gray-600'>
          <p>Don't have an account? Contact the administrator.</p>
        </div>
      </div>
    </div>
  );
}